import type { IMergeTagArray } from "@/schemas/mergeTags/mergeTagsSchema";
import { isPlainMergeTag, mapMergeTagTree } from "@/utils/mergeTags";

export type LinkListItem =
  | { title: string; value: string }
  | { title: string; menu: LinkListItem[] };

/**
 * Converts the grouped merge-tag tree into the shape TinyMCE's `link_list`
 * option expects: nested on `menu`, with the syntax delimiters kept — an href
 * needs the whole tag. (The visual-merge-tags listbox wants the opposite on
 * both counts; see prepareMergeTagsForListBox in TinyMCEEditor.vue.)
 */
export default function mergeTagsToLinkList(
  mergeTags: IMergeTagArray
): LinkListItem[] {
  return mapMergeTagTree<LinkListItem>(mergeTags, {
    mapLeaf: (mergeTag) =>
      isPlainMergeTag(mergeTag.value)
        ? { title: mergeTag.text, value: mergeTag.value }
        : null,
    mapGroup: (title, menu) => ({ title, menu }),
  });
}
